var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"badge-item"},[_c('span',{staticClass:"badge",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.badge))]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }